module.exports = __webpack_public_path__ + "static/2007_petzold+pfeil+riechert_ar-bridge-builder_talk-slides.a79685c9.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/download/2007_petzold+pfeil+riechert_ar-bridge-builder_talk-slides.pdf
// module id = 291
// module chunks = 198518120645259